import { useTranslation } from 'react-i18next';
import { QuestionTypeEnum } from '@/models/Question';
import { DragDropAnswer } from '@/components/question/view/primitives/shared/dnd';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import {
  blankSlotId,
  useFillInTheBlankAnswerView,
} from '@/components/question/view/typologies/fill-in-the-blank/useFillInTheBlankAnswerView';
import isEmpty from 'lodash/isEmpty';

const surface = 'rounded-2xl border border-base-300 bg-base-200 px-4 py-6';

export function FillInTheBlankAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.FILL_IN_THE_BLANK>,
) {
  const {
    segments,
    tokens,
    slots,
    placement,
    handlePlacementChange,
    disabled,
  } = useFillInTheBlankAnswerView(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });

  if (isEmpty(segments) && isEmpty(tokens)) return null;

  return (
    <DragDropAnswer
      tokens={tokens}
      slots={slots}
      placement={placement}
      onPlacementChange={handlePlacementChange}
      disabled={disabled}
      className={surface}
    >
      <p className="text-lg leading-loose text-base-content/50 whitespace-pre-wrap">
        {segments.map((segment, index) =>
          segment.type === 'text' ? (
            <span key={`text-${index}`}>{segment.value}</span>
          ) : (
            <DragDropAnswer.Slot
              key={`blank-${segment.index}`}
              id={blankSlotId(segment.index)}
              inline
              ariaLabel={t('fillInTheBlank.blankLabel', {
                number: segment.index + 1,
              })}
              className="mx-1 my-2 min-w-37 min-h-13 p-0"
            />
          ),
        )}
      </p>
      <DragDropAnswer.Bank />
    </DragDropAnswer>
  );
}
